import React, { useState } from "react";
import PageHero from "../components/PageHero";
import CaseStudiesIndex from "./CaseStudiesIndex";
import BlogIndex from "./BlogIndex";
import { BookOpen, FileText } from "lucide-react";

const InsightsPage = () => {
  const [tab, setTab] = useState("cases");
  return (
    <div>
      <PageHero
        eyebrow="Insights"
        title="Case studies and field notes from the data trenches"
        subtitle="Measurable enterprise outcomes and the write-ups behind them — spanning Microsoft Fabric, Databricks, Snowflake, dbt and governance programs."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "Insights" }]}
      />

      <section className="pt-8 pb-2 bg-[#F5F7FB]">
        <div className="container-x flex items-center gap-3">
          <button
            onClick={() => setTab("cases")}
            className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all ${
              tab === "cases" ? "bg-[#0B1B3B] text-white" : "bg-white text-[#0B1B3B] border border-slate-200 hover:border-[#1E56E3]"
            }`}
          >
            <FileText size={14} /> Case Studies
          </button>
          <button
            onClick={() => setTab("blog")}
            className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all ${
              tab === "blog" ? "bg-[#0B1B3B] text-white" : "bg-white text-[#0B1B3B] border border-slate-200 hover:border-[#1E56E3]"
            }`}
          >
            <BookOpen size={14} /> Blog
          </button>
        </div>
      </section>

      {tab === "cases" ? <CaseStudiesIndex embedded /> : <BlogIndex embedded />}
    </div>
  );
};

export default InsightsPage;
